module.exports = __webpack_public_path__ + "static/media/cy.5f4906b1.svg";